export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const GET_USER = "GET_USER";
export const CHANGE_USER = "CHANGE_USER";
export const GET_INSTITUTE_INFO = "GET_INSTITUTE_INFO";
export const LOGOUT = "LOGOUT";
export const LOADING = "LOADING";